import { GridColumnType } from '@grid'
import { GridPreProcessEditCellProps } from '@mui/x-data-grid'
import { Validator, ValidatorResultType } from '@validators'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export const couponColumns: GridColumnType = {
	initRow: {
		name: '',
		email: '',
		code: '',
		discountUsd: 0,
		discountKrw: 0,
		quantity: 0,
		unitUsd: 0,
		unitKrw: 0,
		usageQuantity: 0,
		totalPayoutDueUsd: 0,
		totalPayoutDueKrw: 0,
		expiredAt: '',
		useYn: 1,
		createdAt: dayjs().format('YYYY-MM-DD HH:mm:ss'),
	},
	fieldToFocus: 'name',
	card: {
		title: 'code',
		subtitle: 'name',
		meta: ['discountUsd', 'discountKrw', 'usageQuantity', 'useYn'],
	},
	columns: [
		{
			field: 'name',
			headerName: '이름',
			headerAlign: 'center',
			preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
				const res: ValidatorResultType = Validator.coupons({
					name: params.props.value,
				})

				return {
					...params.props,
					error: !res.name.isValid,
					errorMessage: res.name.message ?? '',
				}
			},
			width: 150,
			editable: true,
		},
		{
			field: 'email',
			headerName: '이메일',
			headerAlign: 'center',
			width: 150,
			editable: true,
		},
		{
			field: 'code',
			headerName: '코드',
			headerAlign: 'center',
			width: 150,
			editable: false,
		},
		{
			field: 'discountUsd',
			headerName: '할인금액(USD)',
			headerAlign: 'center',
			width: 100,
			editable: true,
			valueFormatter: (value: number) =>
				value.toLocaleString('en-US', {
					style: 'currency',
					currency: 'USD',
				}),
			align: 'right',
		},
		{
			field: 'discountKrw',
			headerName: '할인금액(KRW)',
			headerAlign: 'center',
			width: 100,
			editable: true,
			valueFormatter: (value: number) =>
				value.toLocaleString('ko-KR', {
					style: 'currency',
					currency: 'KRW',
				}),
			align: 'right',
		},
		{
			field: 'quantity',
			headerName: '할당량',
			headerAlign: 'center',
			width: 100,
			editable: true,
			align: 'right',
			valueFormatter: (value: number) => value.toLocaleString(),
		},
		{
			field: 'unitUsd',
			headerName: '건당금액(USD)',
			type: 'number',
			headerAlign: 'center',
			valueFormatter: (value: number) => {
				const res =
					value === 0
						? '-'
						: value.toLocaleString('en-US', {
								style: 'currency',
								currency: 'USD',
						  })

				return res
			},
			width: 70,
			editable: true,
		},
		{
			field: 'unitKrw',
			headerName: '건당금액(KRW)',
			type: 'number',
			headerAlign: 'center',
			valueFormatter: (value: number) => {
				const res =
					value === 0
						? '-'
						: value.toLocaleString('ko-KR', {
								style: 'currency',
								currency: 'KRW',
						  })

				return res
			},
			width: 70,
			editable: true,
		},
		{
			field: 'usageQuantity',
			headerName: '사용량',
			headerAlign: 'center',
			width: 100,
			editable: false,
			align: 'right',
			valueFormatter: (value: number) => (value === 0 ? '-' : value.toLocaleString()),
		},
		{
			field: 'totalPayoutDueUsd',
			headerName: '정산금액(USD)',
			type: 'number',
			headerAlign: 'center',
			valueFormatter: (value: number) => {
				const res =
					value === 0
						? '-'
						: value.toLocaleString('en-US', {
								style: 'currency',
								currency: 'USD',
						  })

				return res
			},
			width: 70,
			editable: false,
		},
		{
			field: 'totalPayoutDueKrw',
			headerName: '정산금액(KRW)',
			type: 'number',
			headerAlign: 'center',
			valueFormatter: (value: number) => {
				const res =
					value === 0
						? '-'
						: value.toLocaleString('ko-KR', {
								style: 'currency',
								currency: 'KRW',
						  })

				return res
			},
			width: 70,
			editable: false,
		},
		{
			field: 'expiredAt',
			headerName: '만료일',
			type: 'dateTime',
			headerAlign: 'center',
			valueFormatter: (value: string) =>
				value !== '' ? dayjs(value).tz().format('YYYY-MM-DD') : '',
			width: 200,
			editable: true,
		},
		{
			field: 'useYn',
			headerName: '사용여부',
			type: 'boolean',
			headerAlign: 'center',
			valueFormatter: (value: number) => (value === 1 ? true : false),
			width: 70,
			editable: true,
		},
		{
			field: 'createdAt',
			headerName: '생성날짜',
			type: 'dateTime',
			headerAlign: 'center',
			valueFormatter: (value: string) =>
				value !== '' ? dayjs(value).tz().format('YYYY-MM-DD HH:mm:ss') : '',
			width: 200,
			editable: false,
		},
	],
}
